<script lang="ts">
  import SolanaShell from "../../components/SolanaShell.svelte";
  import HistoricGraduationsView from "../../components/HistoricGraduationsView.svelte";

  import { updateMeta, injectJsonLd } from "../../seo/meta";
  import { ROUTE_SEO } from "../../seo/routes";
  import { ORGANIZATION_SCHEMA, combineSchemas, getBreadcrumbSchema } from "../../seo/schemas";
  updateMeta(ROUTE_SEO["/tools/solana/graduations"]);
  injectJsonLd(combineSchemas(
    ORGANIZATION_SCHEMA,
    getBreadcrumbSchema([
      { name: "Home", url: "https://0xfire.com/" },
      { name: "Tools", url: "https://0xfire.com/tools" },
      { name: "Solana", url: "https://0xfire.com/tools/solana" },
      { name: "Graduations", url: "https://0xfire.com/tools/solana/graduations" },
    ]),
  ));
</script>

<SolanaShell activePage="graduations">
  <div class="text-center mb-8">
    <h1 class="text-2xl font-bold text-white tracking-tight">
      Pool Graduations
    </h1>
    <p class="text-sm text-gray-500 mt-1">Track PumpFun and Raydium Launchpad pool graduations to mainnet DEXs</p>
  </div>

  <div class="max-w-4xl mx-auto">
    <HistoricGraduationsView />
  </div>

  <div class="max-w-2xl mx-auto mt-16">
    <div class="border-t border-gray-800 pt-10">
      <h2 class="text-lg font-bold text-white mb-4">What are Pool Graduations?</h2>
      <p class="text-sm text-gray-500 leading-relaxed mb-4">
        When a token on a bonding curve platform like <strong class="text-gray-300">PumpFun</strong> or <strong class="text-gray-300">Raydium Launchpad</strong> hits its graduation threshold, it migrates to a full DEX pool on PumpSwap, Raydium AMM, or Raydium CPMM. This event is called a <strong class="text-gray-300">graduation</strong>.
      </p>
      <p class="text-sm text-gray-500 leading-relaxed mb-6">
        Tracking graduations lets you spot newly liquid tokens the moment they become tradeable on mainnet DEXs — useful for sniping, monitoring launch activity, and analyzing launchpad trends.
      </p>
    </div>

    <div class="border-t border-gray-800 pt-10">
      <h2 class="text-lg font-bold text-white mb-6">FAQ</h2>
      <div class="space-y-6">
        <div>
          <h3 class="text-sm font-bold text-white mb-1">Which platforms are tracked?</h3>
          <p class="text-sm text-gray-500 leading-relaxed">PumpFun (graduating to PumpSwap) and Raydium Launchpad (graduating to Raydium AMM or CPMM).</p>
        </div>
        <div>
          <h3 class="text-sm font-bold text-white mb-1">How fresh is the data?</h3>
          <p class="text-sm text-gray-500 leading-relaxed">Data is indexed from on-chain transactions in real-time via the Sailfish API. You can query any date range up to ~67 minutes.</p>
        </div>
        <div>
          <h3 class="text-sm font-bold text-white mb-1">What information is shown per graduation?</h3>
          <p class="text-sm text-gray-500 leading-relaxed">Slot number, pool type (PumpSwap/Raydium), trading pair symbols, transaction hash, and pool address with links to DexScreener and Solscan.</p>
        </div>
      </div>
    </div>
  </div>
</SolanaShell>
